// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import SearchToggleController from "./search_toggle_controller"
application.register("search-toggle", SearchToggleController)
